export default "__VITE_ASSET__DSQ0_I39__"